import React from 'react';
import { AlertTriangle } from 'lucide-react';

const TORT_COLORS: Record<string, string> = {
  RLP: 'bg-green-100 text-green-700 border-green-300',
  PFAS: 'bg-amber-100 text-amber-700 border-amber-300',
  VGA: 'bg-blue-100 text-blue-700 border-blue-300',
  SMA: 'bg-purple-100 text-purple-700 border-purple-300',
};

interface OverlapFlag {
  tortCode: string;
  matchType: string;
  confidenceScore: string;
  ruleApplied: string;
  evidenceOnFile: string[];
  evidenceGaps: string[];
}

interface Deficiency {
  deficiencyCode: string;
  message: string;
  severity: string;
  raisedAt: string;
  clearedAt?: string;
}

interface OverlapFlagsCellProps {
  overlapFlags?: OverlapFlag[];
  deficiencies?: Deficiency[];
  onDeficiencyClick?: () => void;
}

export const OverlapFlagsCell: React.FC<OverlapFlagsCellProps> = ({
  overlapFlags,
  deficiencies,
  onDeficiencyClick,
}) => {
  const hasFlags = overlapFlags && overlapFlags.length > 0;
  const hasDeficiencies = deficiencies && deficiencies.length > 0;

  if (!hasFlags && !hasDeficiencies) {
    return <span className="text-xs text-gray-400">&mdash;</span>;
  }

  return (
    <div className="flex flex-wrap gap-1 items-center">
      {overlapFlags?.map((flag) => (
        <span
          key={flag.tortCode}
          className={`inline-flex items-center px-1.5 py-0.5 rounded border text-xs font-medium ${TORT_COLORS[flag.tortCode] || 'bg-gray-100 text-gray-600 border-gray-300'}`}
        >
          {flag.tortCode}
        </span>
      ))}
      {hasDeficiencies && (
        <button
          onClick={(e) => { e.stopPropagation(); onDeficiencyClick?.(); }}
          className="ml-1 p-1 hover:bg-red-50 rounded-full transition-colors"
          aria-label="View deficiencies"
        >
          <AlertTriangle className="h-4.5 w-4.5 text-red-500" />
        </button>
      )}
    </div>
  );
};

export default OverlapFlagsCell;